import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router,Route,Switch,Redirect} from "react-router-dom";
import {Testbutton} from "./test/Testbutton";
import {Zhuye} from "./test/Zhuye";
import {NotFind} from "./test/NotFind";
import {AuthLogin} from "./Common/Auth"
import {message} from "antd";
import {AdminLogin} from "./Pages/login/AdminLogin";
import cookie from "react-cookies"
import {ClassAndStudent} from "./Pages/Admin/ClassAndStudent";
import {StudentLayout} from "./Pages/Admin/StudentPage/StudentLayout";
import {TaskLayout} from "./Pages/Admin/TaskPage/TaskLayout";
import {ExperimentLayout} from "./Pages/User/experimentPage/ExperimentLayout";
import {ExperimentDetailsLayout} from "./Pages/User/experimentPage/ExperimentDetailsLayout";
import {UserLogin} from "./Pages/User/login/UserLogin";
import {UserLayout} from "./Pages/User/accountManagement/UserLayout";
import {ResourcesPageLayout} from "./Pages/User/experimentResources/ResourcesPageLayout";
import {HomeworkCorrectionLayout} from "./Pages/User/HomeworkCorrection/HomeworkCorrectionLayout";
import {KnowledgeLibraryLayout} from "./Pages/User/knowledgeLibrary/KnowledgeLibraryLayout";
import {VideoLayout} from "./Pages/User/VideoPageLayout/VideoLayout";
import {VideoAndOtherFile} from "./Pages/User/VideoPageLayout/VideoAndOtherFile";
import {FileViewerTool} from "./Pages/User/Util/fileViewer/FileViewerTool";
import {ClassLayout} from "./Pages/User/ClassPage/ClassLayout";
import {StudentTableLayout} from "./Pages/User/StuentPage/StudentTableLayout";
import {RegisterLayout} from "./Pages/Admin/registerCode/RegisterLayout";
import DocumentTitle from 'react-document-title'
import {TeacherTableLayout} from "./Pages/Admin/teacherTablePage/TeacherTableLayout";
import {AdminInfo} from "./Pages/Admin/adminInfo/AdminInfo";


function App() {


    let as
    const username = "username"
    const role = "role"
    const roleTest = "admin"
    const roleUserTest = "student"
    const roleTeacherTest = "teacher"
      return (
          <>
            <Router basename={"/admin"}>
                <Switch>
                    <Route exact path={"/login"} component={AdminLogin}></Route>
                    <Route path={"/class"} render={(props)=>{
                        //let coo = $.cookie("role")
                        if (cookie.load(username)!== null && cookie.load(role) === "admin"){
                            return <ClassAndStudent></ClassAndStudent>
                        }
                        return <Redirect to={"/login"}></Redirect>
                    }}></Route>
                    <Route path={"/student"} render={(props)=>{
                        if (cookie.load(username)!== null && cookie.load(role) === "admin"){
                            return <StudentLayout {...props}></StudentLayout>
                        }
                        return <Redirect to={"/login"}></Redirect>
                    }}></Route>
                    <Route path={"/teacher"} render={(props)=>{
                        if (cookie.load(username)!== null && cookie.load(role) === "admin"){
                            return <TeacherTableLayout {...props}></TeacherTableLayout>
                        }
                        return <Redirect to={"/login"}></Redirect>
                    }}></Route>
                    <Route path={"/adminInfo"} render={(props)=>{
                        if (cookie.load(username)!== null && cookie.load(role) === "admin"){
                            return <AdminInfo {...props}></AdminInfo>
                        }
                        return <Redirect to={"/login"}></Redirect>
                    }}></Route>
                    {/*<Route path={"/registerCode"} render={(props)=>{*/}
                    {/*    if (cookie.load(username)!== null && cookie.load(role) === "admin"){*/}
                    {/*        return <RegisterLayout {...props}></RegisterLayout>*/}
                    {/*    }*/}
                    {/*    return <Redirect to={"/login"}></Redirect>*/}
                    {/*}}>*/}
                    {/*</Route>*/}
                    <Route path={"/task"} render={(props)=>{
                        if (cookie.load(username)!== null && cookie.load(role) === "admin"){
                            return <TaskLayout {...props}></TaskLayout>
                        }
                        return <Redirect to={"/login"}></Redirect>
                    }}>
                    </Route>
                </Switch>
                <DocumentTitle title="审计机器人教学平台">
                </DocumentTitle>
            </Router>
            <Router basename={"/user"}>
                <Switch>
                    <Route exact path={"/"} component={UserLogin}></Route>
                    <Route exact path={"/experi"} render={(props)=>{
                        if (cookie.load(username)!==null && Object.is(cookie.load(role),cookie.load(roleUserTest))){
                            return <ExperimentLayout></ExperimentLayout>
                        }
                        return <Redirect to={"/"}></Redirect>
                    }}></Route>
                    <Route exact path={"/userInfo"} render={(props)=>{
                        if (cookie.load(username)!==null && cookie.load(role)==="student" || cookie.load(role) === "teacher"){
                            return <UserLayout {...props}></UserLayout>
                        }
                        return <Redirect to={"/"}></Redirect>
                    }}></Route>
                    <Route exact path={"/resources"} render={(props)=>{
                        if (cookie.load(username)!==null && cookie.load(role)==="teacher"){
                            return <ResourcesPageLayout {...props}></ResourcesPageLayout>
                        }
                        return <Redirect to={"/"}></Redirect>
                    }}></Route>
                    <Route exact path={"/homeworkCorrection"} render={(props)=>{
                        if (cookie.load(username)!==null && cookie.load(role)==="teacher"){
                            return <HomeworkCorrectionLayout {...props}></HomeworkCorrectionLayout>
                        }
                        return <Redirect to={"/"}></Redirect>
                    }}></Route>
                    <Route exact path={"/knowledgeLibrary"} render={(props)=>{
                        if (cookie.load(username)!==null && cookie.load(role)==="student" || cookie.load(role) === "teacher"){
                            return <KnowledgeLibraryLayout {...props}></KnowledgeLibraryLayout>
                        }
                        return <Redirect to={"/"}></Redirect>
                    }}></Route>
                    <Route exact path={"/classTable"} render={(props)=>{
                        if (cookie.load(username)!==null && cookie.load(role)==="teacher"){
                            return <ClassLayout></ClassLayout>
                        }
                        return <Redirect to={"/"}></Redirect>
                    }}></Route>
                    <Route exact path={"/studentTable"} render={(props)=>{
                        if (cookie.load(username)!==null && cookie.load(role)==="teacher"){
                            return <StudentTableLayout></StudentTableLayout>
                        }
                        return <Redirect to={"/"}></Redirect>
                    }}></Route>
                    <Route exact path={"/fileView"} component={FileViewerTool}></Route>
                    <Route exact path={"/videoAndOtherFile"} component={VideoAndOtherFile}></Route>
                    <Route exact path={"/video"} component={VideoLayout}></Route>
                    <Route exact path={"/experimentDetails"} component={ExperimentDetailsLayout}></Route>
                </Switch>
                <DocumentTitle title="审计机器人教学平台">
                </DocumentTitle>
            </Router>
            {/*<Router>*/}
            {/*    <Switch>*/}
            {/*        <Route component={NotFind}></Route>*/}
            {/*    </Switch>*/}
            {/*</Router>*/}
          </>
      );
}

export default App;
